module.exports = __webpack_public_path__ + "img/01.5fc3d047.png";